import { api } from 'data/api/api'

import { ReturnLabelOrderResp } from '../types/return-shipment'

export const prepareReturnLabelOrder = ({ transactionId }) =>
  api.post<ReturnLabelOrderResp>('/return_label/orders/prepare', {
    transaction_id: transactionId,
  })
